import { default as api } from 'config/adminApiConf.js';

export const addEventService = async (data) => {
	try {
		let result = await api.post(`/event/create`, data);
		return result;
	} catch (error) {
		return error;
	}
};
export const listEventType = async (data) => {
	try {
		let result = await api.get(`/event-type`, data);
		return result;
	} catch (error) {
		return error;
	}
};
